/**
 * Module-level API client glue.
 *
 * Every page reads the configured base URL via {@link loadConfig} and pulls
 * the access token from the AuthContext via the `useApi` hook. This keeps
 * pages free of fetch boilerplate while keeping the underlying fetch
 * wrapper testable as a pure function.
 */

import { useMemo } from 'react';
import { useAuth } from './auth/AuthContext';
import { createApiClient } from './auth/api-client';
import { loadConfig } from './config';

/** React hook that returns a configured API client bound to the current auth state. */
export function useApi() {
  const { getAccessToken } = useAuth();
  return useMemo(
    () => createApiClient({ baseUrl: loadConfig().apiBaseUrl, getAccessToken }),
    [getAccessToken],
  );
}

/** API client for the isolated documentation-grounded help service. */
export function useHelpApi() {
  const { getAccessToken } = useAuth();
  return useMemo(
    () => createApiClient({ baseUrl: loadConfig().helpApiBaseUrl, getAccessToken }),
    [getAccessToken],
  );
}
